export async function exportTxt() {
  const res = await fetch('/api/cards?status=active&sort=created_at&order=asc', { credentials: 'include' });
  const data = await res.json();
  const cards = Array.isArray(data) ? data : [];
  if (cards.length === 0) return;
  const text = cards.map(c => c.body).join('\n\n');
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `gleaner-all-cards-${new Date().toISOString().slice(0, 10)}.txt`;
  a.click();
  URL.revokeObjectURL(url);
}

function toCSVField(val) {
  const s = String(val || '');
  const q = '"';
  if (s.includes(',') || s.includes(q) || s.includes('\n')) {
    return q + s.split(q).join(q + q) + q;
  }
  return s;
}

export async function exportCsv() {
  const res = await fetch('/api/cards?status=active&sort=created_at&order=asc', { credentials: 'include' });
  const data = await res.json();
  const cards = Array.isArray(data) ? data : [];
  if (cards.length === 0) return;
  const rows = ['body,tags'];
  cards.forEach(c => {
    const tagNames = (c.tags || []).map(t => t.name).join(',');
    rows.push(toCSVField(c.body) + ',' + toCSVField(tagNames));
  });
  const csv = rows.join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `gleaner-export-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
